import CompetitorComparison from './CompetitorComparison';

export default CompetitorComparison;
